var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { Observable, of, throwError } from 'rxjs';
import * as fromStore from '../_store';
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators';
import { DocumentTypeIndraService } from '@ibe.services/document-type-indra.service';
import { FrequentFlyerIndraService } from '@ibe.services/frequent-flyer-indra.service';
import { PassengerPctcService } from '@ibe.services/passenger-pctc.service';
import { PassengerApisService } from '@ibe.services/passenger-apis.service';
import { PassengerFqtvService } from '@ibe.services/passenger-fqtv.service';
import { PassengerContactsService } from '@ibe.services/passenger-contacts.service';
import { PassengerService } from '@ibe.services/passenger.service';
import * as _ from 'lodash';
import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';
var PassengersDetailsEffects = /** @class */ (function () {
    function PassengersDetailsEffects(actions$, dataStorageService, documentService, frequentFlyerService, passengerPctcService, passengerApisService, passengerFqtvService, passengerContactsService, passengerService, timeoutSvc, parallelService) {
        var _this = this;
        this.actions$ = actions$;
        this.dataStorageService = dataStorageService;
        this.documentService = documentService;
        this.frequentFlyerService = frequentFlyerService;
        this.passengerPctcService = passengerPctcService;
        this.passengerApisService = passengerApisService;
        this.passengerFqtvService = passengerFqtvService;
        this.passengerContactsService = passengerContactsService;
        this.passengerService = passengerService;
        this.timeoutSvc = timeoutSvc;
        this.parallelService = parallelService;
        this.loadBookedTrip$ = this.actions$.pipe(ofType(fromStore.ActionTypes.LOADING), switchMap(function () {
            return of(_this.dataStorageService.INDRA_getActiveBookedTrip());
        }), map(function (data) {
            return new fromStore.PutBookedTripPassengersDetailsAction(data);
        }));
        this.loadDocumentTypes$ = this.actions$.pipe(ofType(fromStore.ActionTypes.LOAD_DOCUMENT_TYPES), switchMap(function () { return _this.documentService.getDocumentTypes(); }), map(function (data) { return new fromStore.LoadDocumentTypesSuccess(data); }));
        this.loadFrequentFlyerPrograms$ = this.actions$.pipe(ofType(fromStore.ActionTypes.LOAD_FREQUENT_FLYER_PROGRAMS), switchMap(function () { return _this.frequentFlyerService.getFrequentFlyerPrograms(); }), map(function (data) { return new fromStore.LoadFrequentFlyerProgramsSuccess(data); }));
        this.loadCompanionList$ = this.actions$.pipe(ofType(fromStore.ActionTypes.LOAD_COMPANION_LIST), switchMap(function () { return _this.frequentFlyerService.getCompanionList(); }), map(function (data) { return new fromStore.LoadFrequentFlyerProgramsSuccess(data); }));
        this.savePassenger$ = this.actions$.pipe(ofType(fromStore.ActionTypes.SAVE_PASSENGER), map(function (action) { return ({ data: action.payload, pnr: action.pnr, passenger_id: action.passenger_id }); }), switchMap(function (request) { return _this.passengerService.savePassenger(request.data, request.pnr, request.passenger_id).pipe(concatMap(function (res) {
            if (!_.isNil(res)
                && _.has(res, 'status')
                && _.has(res, 'errors')) {
                var errors = res.errors, status_1 = res.status;
                if (Object.is(+status_1, 200) && _.isEmpty(errors)) {
                    return of(res);
                }
                else {
                    return throwError(errors);
                }
            }
            return of(res);
        }), map(function (resp) { return new fromStore.SavePassengerSuccess({ rq: request, res: resp }); }), catchError(function (errors) { return of(new fromStore.SavePassengerErrors(errors)); })); }));
        this.saveNewPassenger$ = this.actions$.pipe(ofType(fromStore.ActionTypes.SAVE_NEW_PASSENGER), map(function (action) { return ({ data: action.payload, passenger_id: action.passenger_id, passenger_type: action.passenger_type }); }), switchMap(function (request) {
            _this.parallelService.INDRA_setTriggerCreatePassenger(true);
            return _this.passengerService.saveNewPassenger(request.data, request.passenger_id, request.passenger_type)
                .pipe(concatMap(function (res) {
                if (!_.isNil(res)
                    && _.has(res, 'status')
                    && _.has(res, 'errors')) {
                    _this.timeoutSvc.isOtherAPILoading$.next(false);
                    var errors = res.errors, status_2 = res.status;
                    if (Object.is(+status_2, 200) && _.isEmpty(errors)) {
                        return of(res);
                    }
                    else {
                        return throwError(errors);
                    }
                }
                /*
                if (!_.isNil(res)
                    && _.has(res, 'errors')) {
                    const {errors, status} = res;
                    if (_.isEmpty(errors)) {
                        return of(res);
                    } else {
                        return throwError(errors);
                    }
                }
                return of(res);
                */
            }), map(function (resp) { return new fromStore.SavePassengerSuccess({ rq: request, res: resp }); }), catchError(function (errors) {
                _this.timeoutSvc.isOtherAPILoading$.next(false);
                return of(new fromStore.SavePassengerErrors(errors));
            }));
        }));
        this.savePassengerResult$ = this.actions$.pipe(ofType(fromStore.ActionTypes.SAVE_PASSENGER_SUCCESS, fromStore.ActionTypes.SAVE_PASSENGER_ERRORS), tap(function (action) {
            _this.parallelService.INDRA_setTriggerCreatePassenger(false);
            _this.parallelService.INDRA_setIsPassengerCreated(true);
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PassengersDetailsEffects.prototype, "loadBookedTrip$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PassengersDetailsEffects.prototype, "loadDocumentTypes$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PassengersDetailsEffects.prototype, "loadFrequentFlyerPrograms$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PassengersDetailsEffects.prototype, "loadCompanionList$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PassengersDetailsEffects.prototype, "savePassenger$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], PassengersDetailsEffects.prototype, "saveNewPassenger$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], PassengersDetailsEffects.prototype, "savePassengerResult$", void 0);
    return PassengersDetailsEffects;
}());
export { PassengersDetailsEffects };
